// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sf8rx","select":"styles_select__ICVGh"};